import { gql } from '@apollo/client';

export const CREATE_COURSE_MUTATION = gql`
    mutation createCourse($input: CourseInput!) {
        result: createCourse(input: $input) {
            id
            locales {
                locale
                name
                description
            }
            heroImage {
                id
                url
            }
            points
            tags
            isPublic
            isSequential
            isActive
            learningObjects {
                edges {
                    assignment {
                        status
                        scormState
                    }
                    node {
                        id
                        locales {
                            locale
                            name
                            description
                        }
                        duration
                        content {
                            id
                            url
                        }
                    }
                }
            }
        }
    }
`;

// input CourseInput {
//     id: UUID!
//     locales: [CourseLocaleInput!]!
//     isPublic: Boolean
//     isSequential: Boolean
//     heroImageId: UUID
//     bannerImageId: UUID
//     tags: [String!]
//     learningObjectIds: [UUID!]
// }
